import { render, staticRenderFns } from "./logo-svg-icon.vue?vue&type=template&id=3d35936d"
import script from "./logo-svg-icon.vue?vue&type=script&lang=js"
export * from "./logo-svg-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports